import React, { FC, useState } from 'react';
import { CurrentLocationCoordinates } from 'interfaces/components';
import { CONTACT_ADDRESSES } from 'config/contacts';
import { Box, makeStyles, Theme } from '@material-ui/core';
import { ContactLocation } from 'containers/common/sections/contact-us';
import InlineImageTextBlocks from 'components/energy5/structures/InlineImageTextBlocks';
import { PhoneIcon, EnvelopeIcon, LocationIcon } from 'assets/svgs/contact-us';
import { PHONE_NUMBER } from "evcharging/app";
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    contactWrapper: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(-13),
    },
  };
});

const FindUsSection: FC = () => {
  const { t } = useI18n();

  const { lat, lng } = CONTACT_ADDRESSES[0];
  const [currentLocation] = useState<CurrentLocationCoordinates>({ lat, lng });
  const classes = useStyles();

  return (
    <Box>
      <ContactLocation
        className={classes.contactWrapper}
        hideElements
        currentLocation={currentLocation}
      />
      <InlineImageTextBlocks
        data={[
          {
            image: <PhoneIcon />,
            title: t('form.label.phone'),
            description: { text: PHONE_NUMBER, href: `tel:${PHONE_NUMBER}` },
          },
          {
            image: <EnvelopeIcon />,
            title: t('form.label.email'),
            description: {
              text: 'hello@energy5.com',
              href: 'mailto:hello@energy5.com',
            },
          },
          {
            image: <LocationIcon />,
            title: t('form.label.address'),
            description: {
              text: '300 W Somerdale Rd, Suite 5, Voorhees Township, NJ 08043',
              href: 'https://goo.gl/maps/EZQtK9dQ7KAi8Yiy9',
            },
          },
        ]}
      />
    </Box>
  );
};

export default FindUsSection;
